import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import {FolioItem} from "crqlar-react-common/dist/models/billing/folioItem.model";
import {useState} from "react";
import {useTranslation} from "react-i18next";

interface Props {
    /** The line whose code changes; mount the dialog only while there is one. */
    line: FolioItem
    onApply: (marketCode: string) => void
    onClose: () => void
}

/** The line's market code (SKU) - picking a service sets it from the service. */
const FolioMarketCodeDialog = ({line, onApply, onClose}: Props) => {
    const {t} = useTranslation();
    const [code, setCode] = useState(line.serviceInventoryCode ?? '');
    const apply = () => onApply(code.trim());

    return (
        <Dialog open onClose={onClose} maxWidth={'xs'} fullWidth>
            <DialogTitle>{t('Market code (SKU)')}</DialogTitle>
            <DialogContent>
                {!!line.description && <DialogContentText sx={{mb: 2}}>{line.description}</DialogContentText>}
                <TextField
                    fullWidth
                    autoFocus
                    size={'small'}
                    label={t('Market code (SKU)')}
                    value={code}
                    onChange={event => setCode(event.target.value)}
                    onKeyDown={event => {
                        if (event.key === 'Enter') apply();
                    }}
                    sx={{mt: 1}}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Cancel')}</Button>
                <Button onClick={apply} variant={'contained'}>{t('Apply')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FolioMarketCodeDialog;
